(function () {
  'use strict';

  var stickySelector = '[data-seaspray-sticky-atc]';
  var primarySelector = '.product-purchase-form button[type="submit"][data-add-to-cart-text]';
  var scheduled = false;

  function primaryButton(stickyBar) {
    var productDetail = stickyBar.closest('.product-detail');
    return productDetail ? productDetail.querySelector(primarySelector) : null;
  }

  function syncStickyBar(stickyBar) {
    var primary = primaryButton(stickyBar);
    var stickyButton = stickyBar.querySelector('[data-seaspray-sticky-atc-button]');
    if (!primary || !stickyButton) return;

    stickyButton.innerHTML = primary.innerHTML;
    stickyButton.disabled = primary.disabled;
    stickyButton.setAttribute('aria-disabled', primary.disabled ? 'true' : 'false');
  }

  function shouldShow(stickyBar) {
    if (!window.matchMedia('(max-width: 767.98px)').matches) return false;

    var primary = primaryButton(stickyBar);
    var productSection = stickyBar.closest('[data-linked-product-section]');
    if (!primary || !productSection) return false;

    var primaryRect = primary.getBoundingClientRect();
    var sectionRect = productSection.getBoundingClientRect();
    var sectionVisible = sectionRect.bottom > 0 && sectionRect.top < window.innerHeight;
    var primaryVisible = primaryRect.bottom > 0 && primaryRect.top < window.innerHeight;
    return sectionVisible && !primaryVisible;
  }

  function updateStickyBars() {
    scheduled = false;
    var anyVisible = false;

    document.querySelectorAll(stickySelector).forEach(function (stickyBar) {
      syncStickyBar(stickyBar);
      var visible = shouldShow(stickyBar);
      stickyBar.classList.toggle('seaspray-sticky-atc--visible', visible);
      anyVisible = anyVisible || visible;
    });

    document.body.classList.toggle('has-seaspray-sticky-atc', anyVisible);
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateStickyBars);
  }

  function initialiseStickyBars(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(stickySelector).forEach(function (stickyBar) {
      if (stickyBar.dataset.seasprayStickyInitialised === 'true') return;
      stickyBar.dataset.seasprayStickyInitialised = 'true';

      var primary = primaryButton(stickyBar);
      if (primary && window.MutationObserver) {
        new MutationObserver(scheduleUpdate).observe(primary, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true
        });
      }
    });
    scheduleUpdate();
  }

  document.addEventListener('click', function (event) {
    var stickyButton = event.target.closest('[data-seaspray-sticky-atc-button]');
    if (!stickyButton || stickyButton.disabled) return;

    var stickyBar = stickyButton.closest(stickySelector);
    var primary = stickyBar ? primaryButton(stickyBar) : null;
    if (primary) primary.click();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialiseStickyBars(event.target);
  });

  document.addEventListener('seaspray:linked-product:load', function () {
    initialiseStickyBars(document);
  });

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);

  if (window.jQuery) {
    window.jQuery(window).on('cc-variant-updated.seasprayProductExperience', scheduleUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseStickyBars(document);
    });
  } else {
    initialiseStickyBars(document);
  }
})();
